import * as $ from "jquery";
import "jquery.modal";

const videoModalTemplate = `
	<aside id="video-modal" class="modal videomodal">
		<header class="modal_header">
			<h2></h2>
		</header>
		<iframe class="modal_body-iframe videomodal_video" title="" src="about:blank" allowfullscreen frameborder="0"></iframe>
	</aside>
`;

$(document).on("click", ".videomodal_link", function(this: HTMLElement) {
	let $videoLink = $(this);
	let title = $videoLink.attr("data-title");
	let youtubeID = $videoLink.attr("data-youtube-id");
	let youtubeSrc;
	if (youtubeID != null) {
		youtubeSrc = `https://www.youtube.com/embed/${youtubeID}?autoplay=1`;
	} else {
		youtubeSrc = $videoLink.attr("data-youtube-src");
	}

	let $videoModal = $("video-modal");
	if ($videoModal.length === 0)
		$videoModal = $(videoModalTemplate).appendTo(document.body);

	$videoModal.find("h2").text(title);

	$videoModal.find(".videomodal_video")
		.attr("title", title)
		.attr("src", youtubeSrc);

	$videoModal.modal();

	return false;
});

$(document).on($.modal.CLOSE, "#video-modal", function() {
	$(document).find(".videomodal_video").each(function(this: HTMLElement) {
		$(this).attr("src", "about:blank");
	})
});
